import React, { useContext } from 'react';
import classNames from 'classnames';
import createFromIconfontCN from './IconFont';
import ConfigContext from '../config-provider/ConfigContext';
const Icon = function Icon(props) {
    const { getConfig } = useContext(ConfigContext);
    const iconfontPrefix = getConfig('iconfontPrefix');
    const { type, customFontName, height, width, className = '', scriptUrl, ...otherProps } = props;
    const classString = classNames(iconfontPrefix, customFontName, `${iconfontPrefix}-${type}`, className);
    if (scriptUrl &&
        typeof document !== 'undefined' &&
        typeof window !== 'undefined' &&
        typeof document.createElement === 'function') {
        const SvgIcon = createFromIconfontCN({ scriptUrl });
        if (SvgIcon) {
            return React.createElement(SvgIcon, { type: type, width: width, height: height });
        }
    }
    return React.createElement("i", Object.assign({}, otherProps, { className: classString }));
};
Icon.displayName = 'Icon';
Icon.createFromIconfontCN = createFromIconfontCN;
Icon.__C7N_ICON = true;
export default Icon;
